const alertMixin = {
    props: ['text']
}

export default alertMixin;